// Sticky Header

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * Calls when Component is Initialized in DOM
   *
   */
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
    this.headerBounds = {};
    this.currentScrollTop = 0;

    this.onScrollHandler = this.onScroll.bind(this);
    
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('header-sticky');
    };

    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  /**
   * Calls when Component is removed from DOM
   *
   */
  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  /**
   * To observe Sticky header visibility on User Scroll
   *
   */
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  /**
   * Window Scroll event
   *
   */
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // console.log(scrollTop, this.currentScrollTop, this.headerBounds.bottom);
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  /**
   * Hide Sticky header
   * Close Menu Drawer / Seach Modal / Cart Drawer
   *
   */
  hide() {
    if (!this.headerIsAlwaysSticky){
      this.header.classList.add('header-hidden', 'header-sticky');
      this.closeSearchModal();
      this.closeMenuDropdowns();
    }    
  }

  /**
   * Show Sticky Header
   *
   */
  reveal() {
    if (!this.headerIsAlwaysSticky) {
      this.header.classList.add('header-sticky', 'animate');
      this.header.classList.remove('header-hidden');
    }
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('header-hidden', 'header-sticky', 'animate');
  }

  /**
   * Close Search Modal on Window Scroll
   *
   */
  closeSearchModal() {
    let searchModal = document.querySelector('search-modal') || null;
    if(searchModal == null) return;
    
    if(searchModal.classList.contains('open__modal') && typeof searchModal.close == 'function') searchModal.close(false);
  }

  /**
   * Close Menu Dropdowns
   *
   */
  closeMenuDropdowns() {
    let openDropdowns = Array.from(document.querySelectorAll('.dropdown.open'));
    openDropdowns.forEach((ele) => {
      ele.classList.remove('open');
    });
  }
}
customElements.define('sticky-header', StickyHeader);

class StickyButtonHandler {
  constructor(sectionId, buttonId, headerHeightVar = '--bs-header-height') {
    this.sectionId = sectionId;
    this.buttonId = buttonId;
    this.headerHeightVar = headerHeightVar;

    // Initialize the handler
    this.init();
  }

  // Initialize the handler
  init() {
    this.section = document.getElementById(this.sectionId);
    this.button = document.getElementById(this.buttonId);

    // Validate elements
    if (!this.section || !this.button) {
      console.warn(`Required elements not found. Ensure #${this.sectionId} and #${this.buttonId} exist in the DOM.`);
      return;
    }

    this.headerHeightValue = this.getHeaderHeightValue();
    this.headerHeightValue = this.headerHeightValue + 1;

    // Add scroll event listener
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  // Get header height value from the custom property
  getHeaderHeightValue() {
    const rootStyle = getComputedStyle(document.documentElement);
    const headerHeight = rootStyle.getPropertyValue(this.headerHeightVar)?.trim() || '0px';
    return parseInt(headerHeight, 10) || 0; // Fallback to 0 if parsing fails
  }

  // Handle scroll event
  handleScroll() {
    if (!this.section || !this.button) return;

    if (this.section.getBoundingClientRect().top <= this.headerHeightValue) {
      this.button.classList.remove("d-none"); // Show the button
    } else {
      this.button.classList.add("d-none"); // Hide the button
    }
  }
}

// Usage
const stickyHandler = new StickyButtonHandler("stickySection", "stickyButton");

class MegaMenuToggle {
  constructor(arrowSelector, liSelector) {
    this.arrowSelector = arrowSelector; // Selector for the arrow
    this.liSelector = liSelector;       // Selector for the parent <li> element
    this.init();
  }

  init() {
    // Select all arrow elements
    const arrowElements = document.querySelectorAll(this.arrowSelector);

    arrowElements.forEach(arrow => {
      arrow.addEventListener('click', (e) => this.handleArrowClick(e, arrow));
    });
  }

  handleArrowClick(event, arrow) {
    console.log(event,"event")
    event.preventDefault();

    // Find the parent <li> element
    const parentLi = arrow.closest(this.liSelector);
    if (!parentLi) return;

    // Toggle the 'open' class
    const isOpen = parentLi.classList.contains('open');
    if (isOpen) {
      this.closeMenu(parentLi);
    } else {
      this.openMenu(parentLi);
    }
  }

  openMenu(parentLi) {
    // Close other menus
    this.closeAll();
    // Add the 'open' class to the current <li>
    parentLi.classList.add('open');

    // Add a mouseout event listener to remove the 'open' class when mouse leaves
    parentLi.addEventListener('mouseleave', () => this.closeMenu(parentLi), { once: true });
  }

  closeMenu(parentLi) {
    parentLi.classList.remove('open');
  }

  closeAll() {
    // Remove 'open' class from all <li> elements
    document.querySelectorAll(this.liSelector).forEach(li => li.classList.remove('open'));
  }
}

// Initialize the MegaMenuToggle class
document.addEventListener('DOMContentLoaded', () => {
  new MegaMenuToggle('#mega-menu-arrow', '.nav-item.nav-list.dropdown.megamenu');
});

